<template>
  <v-card :loading="loadingSendAccess" :disabled="loadingSendAccess">
    <v-card-title class="title font-weight-bold primary--text px-9 pt-6 pb-0">
      Se parte de nuestra comunidad
      <v-spacer></v-spacer>
      <v-btn icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="!messageComplete">
      <v-container class="pt-0">
        <v-row>
          <v-col cols="12" class="py-1">
            <div
              class="subtitle-1 mb-2 font-weight-bold"
            >Para postularte a un empleo debes haber participado o estar activo en uno de nuestros cursos.</div>
            <div class="subtitle-1 mb-2 font-weight-bold">
              Para más información escríbenos
              <div class="d-flex align-center">
                <v-icon color="success" class="mr-2">mdi-whatsapp</v-icon>
                <span
                  class="font-weight-bold success--text"
                >{{siteSettings && siteSettings.redes_sociales && siteSettings.redes_sociales.whatsapp}}</span>
              </div>
            </div>
            <p class="body-2 mb-2">Completa el siguiente formulario para obtener más información</p>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <BaseMyTextField
              label="Nombres *"
              v-model="nombres"
              :error-messages="nombresErrors"
              @input="$v.nombres.$touch()"
              @blur="$v.nombres.$touch()"
            ></BaseMyTextField>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <BaseMyTextField
              label="Apellidos *"
              v-model="apellidos"
              :error-messages="apellidosErrors"
              @input="$v.apellidos.$touch()"
              @blur="$v.apellidos.$touch()"
            ></BaseMyTextField>
          </v-col>
          <v-col cols="12" md="7" class="py-1">
            <BaseMyTextField
              label="Correo *"
              v-model="correo"
              :error-messages="correoErrors"
              @input="$v.correo.$touch()"
              @blur="$v.correo.$touch()"
            ></BaseMyTextField>
          </v-col>
          <v-col cols="12" md="5" class="py-1">
            <BaseMyTextField
              label="Teléfono *"
              v-model="telefono"
              :error-messages="telefonoErrors"
              @input="$v.telefono.$touch()"
              @blur="$v.telefono.$touch()"
            ></BaseMyTextField>
          </v-col>
          <v-col cols="12" v-if="errorGlobal" class="font-weight-bold py-0 info--text">
            <span>{{ errorGlobal }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end pb-0">
            <BaseMyButton :borderRadius="100" @click="submit">
              Enviar
              <v-icon>mdi-chevron-right</v-icon>
            </BaseMyButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-text v-else>
      <v-container class="pt-0">
        <v-row>
          <v-col cols="12" class="py-1">
            <div class="title mb-2 font-weight-bold">{{ messageComplete }}</div>
            <div class="subtitle-2 mb-2 font-weight-bold">
              Para más información escríbenos
              <div class="d-flex align-center">
                <v-icon color="success" class="mr-2">mdi-whatsapp</v-icon>
                <span
                  class="font-weight-bold success--text"
                >{{siteSettings && siteSettings.redes_sociales && siteSettings.redes_sociales.whatsapp}}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  validations: {
    nombres: { required },
    apellidos: { required },
    telefono: { required },
    correo: { required, email }
  },
  data() {
    return {
      loadingSendAccess: false,
      nombres: "",
      apellidos: "",
      telefono: "",
      correo: "",
      errorGlobal: "",
      messageComplete: ""
    };
  },
  computed: {
    ...mapState(["siteSettings"]),
    nombresErrors() {
      const errors = [];
      if (!this.$v.nombres.$dirty) return errors;
      !this.$v.nombres.required && errors.push("Campo requerido.");
      return errors;
    },
    apellidosErrors() {
      const errors = [];
      if (!this.$v.apellidos.$dirty) return errors;
      !this.$v.apellidos.required && errors.push("Campo requerido.");
      return errors;
    },
    telefonoErrors() {
      const errors = [];
      if (!this.$v.telefono.$dirty) return errors;
      !this.$v.telefono.required && errors.push("Campo requerido.");
      return errors;
    },
    correoErrors() {
      const errors = [];
      if (!this.$v.correo.$dirty) return errors;
      !this.$v.correo.email && errors.push("El correo es invalido");
      !this.$v.correo.required && errors.push("Campo requerido");
      return errors;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.loadingSendAccess = true;
        this.errorGlobal = "";
        const user = {
          nombres: this.nombres,
          apellidos: this.apellidos,
          telefono: this.telefono,
          correo: this.correo
        };

        this.axios
          .post("/api/postulantes/usuarios-sin-confirmar", user)
          .then(res => {
            this.errorGlobal = "";
            this.messageComplete =
              "Su solicitud ha sido enviada nos pondremos en contacto contigo lo antes posible.";
          })
          .catch(err => {
            if (err.response) {
              if (err.response.data.message === "Usuario existente")
                this.messageComplete =
                  "Su solicitud ha sido enviada nos pondremos en contacto contigo lo antes posible.";
              else if (
                err.response.data.message ===
                "Usuario existente como postulante"
              )
                this.messageComplete =
                  "El correo ingresado ya tiene una cuenta activa";
              else this.errorGlobal = err.response.data.message;
            }
          })
          .finally(() => {
            this.loadingSendAccess = false;
          });
      }
    },
    clear() {
      this.$v.$reset();
      this.nombres = "";
      this.apellidos = "";
      this.telefono = "";
      this.correo = "";
    }
  }
};
</script>

<style>
</style>